import './SellButton.css';
import {Link} from 'react-router-dom';

const SellButton = ({isLoggedIn}) => {
    return(
        <div className="sellbutton-wrapper">
            <Link className="text-decoration-none" to={isLoggedIn ? "/sell" : "/login"}>
                <a className="sell-in-markopedia-btn">
                    {isLoggedIn ? "Jual Sekarang" : "Login"}
                </a>
            </Link>
        </div>
    )
};

export default SellButton;